import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  fetchTeamMembers,
  deleteTeamMember,
  addTeamMember,
  updateTeamMember,
  fetchProjectRoles,
  fetchCertifications,
  fetchUsers,
  getPresignedUrl,
  uploadCertificate,
  createUpdateTeamMember,
  clearTeamMembersError,
  deleteTeamMemberCert,
  createUpdateProjectLevelRoles,
  deleteProjectLevelRole
} from '../actions';

export const useTeamMembersRedux = () => {
  const dispatch = useDispatch();
  const teamMembersState = useSelector((state) => state.teamMembers || {});
  
  const {
    teamMembers,
    loading,
    error,
    deleteLoading,
    addLoading,
    updateLoading,
    projectRoles,
    certifications,
    rolesLoading,
    certificationsLoading,
    users,
    usersLoading,
    presignedUrl,
    presignedUrlLoading,
    uploadLoading,
    createUpdateLoading,
    isRefreshingData,
    deleteCertLoading,
    createUpdateRolesLoading,
    deleteRoleLoading
  } = teamMembersState;

  const fetchTeamMembersAction = useCallback((payload) => {
    dispatch(fetchTeamMembers(payload));
  }, [dispatch]);

  const deleteTeamMemberAction = useCallback((payload) => {
    dispatch(deleteTeamMember(payload));
  }, [dispatch]);

  const addTeamMemberAction = useCallback((payload) => {
    dispatch(addTeamMember(payload));
  }, [dispatch]);

  const updateTeamMemberAction = useCallback((payload) => {
    dispatch(updateTeamMember(payload));
  }, [dispatch]);

  const fetchProjectRolesAction = useCallback((payload) => {
    dispatch(fetchProjectRoles(payload));
  }, [dispatch]);

  const fetchCertificationsAction = useCallback((payload) => {
    dispatch(fetchCertifications(payload));
  }, [dispatch]);

  const fetchUsersAction = useCallback((payload) => {
    dispatch(fetchUsers(payload));
  }, [dispatch]);

  const getPresignedUrlAction = useCallback((payload) => {
    dispatch(getPresignedUrl(payload));
  }, [dispatch]);

  const uploadCertificateAction = useCallback((payload) => {
    dispatch(uploadCertificate(payload));
  }, [dispatch]);

  const createUpdateTeamMemberAction = useCallback((payload) => {
    dispatch(createUpdateTeamMember(payload));
  }, [dispatch]);

  const clearTeamMembersErrorAction = useCallback(() => {
    dispatch(clearTeamMembersError());
  }, [dispatch]);

  const createUpdateProjectLevelRolesAction = useCallback((payload) => {
    dispatch(createUpdateProjectLevelRoles(payload));
  }, [dispatch]);

  const deleteProjectLevelRoleAction = useCallback((payload) => {
    dispatch(deleteProjectLevelRole(payload));
  }, [dispatch]);

  return {
    teamMembers: teamMembers || [],
    loading: loading || false,
    error: error || null,
    deleteLoading: deleteLoading || false,
    addLoading: addLoading || false,
    updateLoading: updateLoading || false,
    projectRoles: projectRoles || [],
    certifications: certifications || [],
    rolesLoading: rolesLoading || false,
    certificationsLoading: certificationsLoading || false,
    users: users || [],
    usersLoading: usersLoading || false,
    presignedUrl: presignedUrl || null,
    presignedUrlLoading: presignedUrlLoading || false,
    uploadLoading: uploadLoading || false,
    createUpdateLoading: createUpdateLoading || false,
    isRefreshingData: isRefreshingData || false,
    deleteCertLoading: deleteCertLoading || false,
    createUpdateRolesLoading: createUpdateRolesLoading || false,
    deleteRoleLoading: deleteRoleLoading || false,
    fetchTeamMembers: fetchTeamMembersAction,
    deleteTeamMember: deleteTeamMemberAction,
    addTeamMember: addTeamMemberAction,
    updateTeamMember: updateTeamMemberAction,
    fetchProjectRoles: fetchProjectRolesAction,
    fetchCertifications: fetchCertificationsAction,
    fetchUsers: fetchUsersAction,
    getPresignedUrl: getPresignedUrlAction,
    uploadCertificate: uploadCertificateAction,
    createUpdateTeamMember: createUpdateTeamMemberAction,
    clearTeamMembersError: clearTeamMembersErrorAction,
    deleteTeamMemberCert: useCallback((certId, projectId) => {
      dispatch(deleteTeamMemberCert(certId, projectId));
    }, [dispatch]),
    createUpdateProjectLevelRoles: createUpdateProjectLevelRolesAction,
    deleteProjectLevelRole: deleteProjectLevelRoleAction
  };
}; 